
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab  } from '@fortawesome/free-brands-svg-icons'
import { faHeartBroken } from '@fortawesome/free-solid-svg-icons'

library.add(fab, faHeartBroken)